import React, { Component, createRef } from "react";

// Helper
import { setCookie, checkCookie } from "../../Helper/Cookies";
import { apiFetch, getCurrentUser } from "../../Helper/Api";

// Components
import Header from "../../components/Header/Header";
import { Panel, Confirm } from "../../components/UI/Overlays";
import { EmptyState, TableWait, Chip, Tip } from "../../components/UI/Feedback";
import { Toolbar, SelectEmpty } from "../../components/UI/Controls";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
// Properties
const properties = require("../../properties.json");

const TYPE_LIST = [
  { label: "ثابت", value: 0 },
  { label: "تعويض", value: 1 },
  { label: "فاينال", value: 2 },
];

const DAY_LIST = [
  { label: "السبت", value: 6 },
  { label: "الأحد", value: 7 },
  { label: "الاتنين", value: 1 },
  { label: "الثلاثاء", value: 2 },
  { label: "الاربعاء", value: 3 },
  { label: "الخميس", value: 4 },
  { label: "الجمعه", value: 5 },
];

const DAY_LABEL = Object.fromEntries(DAY_LIST.map((d) => [d.value, d.label]));
const TYPE_LABEL = Object.fromEntries(TYPE_LIST.map((t) => [t.value, t.label]));
const TYPE_KIND = { 0: "ok", 1: "wait", 2: "bad" };

/** The API sends an Instant; PrimeReact's Calendar wants a Date. The list used
 *  to overwrite these with "HH:MM:SS" strings on load, which is why the edit
 *  dialog's pickers came up empty -- they were handed a string. The rows keep
 *  the value the server sent, and these two turn it into a Date or a label
 *  only where one is needed. */
const toDate = (v) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

const fmtTime = (v) => {
  const d = toDate(v);
  if (!d) return null;
  return d.toLocaleTimeString("ar-EG", { hour: "2-digit", minute: "2-digit" });
};

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    // Submit Button
    buttonText: "إضافة ميعاد",
    buttonColor: "",

    // Teacher Identifier
    branchID: getCurrentUser()?.branchId,
    companyID: properties.company_id,
    globalFilter: null,
    // Get Data
    data: [],
    allGrades: [],
    getMaterialsList: [],

    // ---- the add form, in its own panel ----
    addOpen: false,
    saving: false,
    notes: null,
    type: null,
    day: null,
    schoolStageId: null,
    selectedMaterial: null,
    date1: null,
    date2: null,
    date3: null,
    date4: null,

    // ---- the edit form, its own state, filled from the row ----
    // These used to be read off `editableData` and off the ADD form's own
    // `notes`, which is why editing a row saved the other form's remarks.
    editRow: null,
    editType: null,
    editDay: null,
    editStage: null,
    editLocation: null,
    editRemarks: "",
    editTime1: null,
    editTime2: null,
    editTime3: null,
    editTime4: null,
    editSaving: false,

    // id -> name, so a row can name the place it is in
    locationsById: {},
    stagesById: {},

    // the rows are on their way
    tableLoading: true,
    loadingLocations: true,
    loadingGrades: true,

    // the appointment the teacher asked to delete, held while the confirm is
    // on screen. The delete behind it is the same call it always was.
    doomed: null,
    deleting: false,
  };

  getMaterial = () => {
    // Get Lesson Locations From API
    apiFetch("/lookup/lesson-locations", { query: { branchId: this.state.branchID } })
      .then((fetchMaterials) => {
        const locationsById = {};
        fetchMaterials.forEach((m) => { locationsById[m.id] = m.name; });
        this.setState({
          getMaterialsList: fetchMaterials,
          locationsById,
          loadingLocations: false,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loadingLocations: false });
      });
  };

  componentDidMount() {
    document.title = properties.site_name + " | المواعيد";

    this.allAppoinments();
    // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
    if (!checkCookie("name")) {
      window.localStorage.removeItem("currentTeacher");
      window.location.href = `/`;
    }

    this.getMaterial();

    apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
      .then((grades) => {
        const stagesById = {};
        grades.forEach((g) => { stagesById[g.id] = g.name; });
        this.setState({ allGrades: grades, stagesById, loadingGrades: false });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loadingGrades: false });
      });
  }

  allAppoinments = () => {
    var _this = this;
    this.setState({ tableLoading: true });
    // The rows are kept exactly as the server sent them. They used to be
    // rewritten here -- each time turned into a "HH:MM:SS" string -- which
    // left the edit pickers with nothing they could read.
    apiFetch("/appointments")
      .then((done) => {
        this.setState({ data: done, tableLoading: false });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ tableLoading: false });
        _this.toast.current.show({
          severity: "error",
          summary: "لم تتم العملية",
          detail: error.message || "خطأ في الإتصال",
        });
      });
  };

  // The pencil opens a form that already holds the appointment's own values.
  openEdit = (row) => {
    this.setState({
      editRow: row,
      editType: row.appointmentsType ?? null,
      editDay: row.day ?? null,
      editStage: row.schoolStageId ?? null,
      editLocation: row.lessonLocationId ?? null,
      editRemarks: row.remarks || "",
      editTime1: toDate(row.time),
      editTime2: toDate(row.time2),
      editTime3: toDate(row.time3),
      editTime4: toDate(row.time4),
    });
  };

  closeEdit = () => {
    this.setState({ editRow: null });
    this.allAppoinments();
  };

  edit = () => {
    var _this = this;
    this.setState({ editSaving: true });
    // Same call, same field names. They are read from the edit form's own
    // state now: `lessonLocationId` used to be taken from `materialsId`, which
    // is not a field on an appointment, so it posted undefined and cleared the
    // place; `remarks` used to come from the add form's notes box.
    apiFetch(`/appointments/${this.state.editRow.id}`, {
      method: "PUT",
      body: {
        appointmentsType: this.state.editType,
        day: this.state.editDay,
        time: this.state.editTime1,
        time2: this.state.editTime2,
        time3: this.state.editTime3,
        time4: this.state.editTime4,
        lessonLocationId: this.state.editLocation,
        schoolStageId: this.state.editStage,
        branchId: this.state.branchID,
        remarks: this.state.editRemarks,
      },
    })
      .then(() => {
        _this.toast.current.show({
          severity: "success",
          summary: "تم بنجاح",
          detail: "تم التعديل بنجاح",
        });
        _this.setState({ editSaving: false });
        _this.closeEdit();
      })
      .catch((error) => {
        console.error("Error:", error);
        _this.setState({ editSaving: false });
        _this.toast.current.show({
          severity: "error",
          summary: "لم تتم العملية",
          detail: error.message || "خطأ في الإتصال",
        });
      });
  };

  addSchedule = () => {
    var _this = this;
    this.setState({ saving: true, buttonText: "جاري الإضافة ...", buttonColor: "loading" });
    // Send the data to the server
    apiFetch("/appointments", {
      method: "POST",
      body: {
        appointmentsType: this.state.type,
        lessonLocationId: this.state.selectedMaterial,
        schoolStageId: this.state.schoolStageId,
        day: this.state.day,
        time: this.state.date1,
        time2: this.state.date2,
        time3: this.state.date3,
        time4: this.state.date4,
        branchId: this.state.branchID,
        remarks: this.state.notes,
      },
    })
      .then(() => {
        _this.toast.current.show({
          severity: "success",
          summary: "تم بنجاح",
          detail: "تمت إضافة الميعاد بنجاح",
        });
        // the save finished the job, so the panel closes and the table behind
        // it goes and fetches what was just added
        _this.setState({
          saving: false,
          buttonText: "إضافة ميعاد",
          buttonColor: "",
          addOpen: false,
          type: null,
          day: null,
          schoolStageId: null,
          selectedMaterial: null,
          notes: null,
          date1: null,
          date2: null,
          date3: null,
          date4: null,
        });
        this.allAppoinments();
      })
      .catch((error) => {
        console.error("Error:", error);
        _this.setState({ saving: false, buttonText: "إضافة ميعاد", buttonColor: "" });
        _this.toast.current.show({
          severity: "error",
          summary: "لم تتم العملية",
          detail: error.message || "خطأ في الإتصال",
        });
      });
  };

  render() {
    const { tableLoading, doomed, deleting, editRow, data } = this.state;

    const grades = this.state.allGrades.map((grade) => {
      return { label: grade.name, value: grade.id };
    });

    let materialList = this.state.getMaterialsList.map((period) => {
      return { label: period.name, value: period.id };
    });

    var deletePeriod = (e) => {
      var _this = this;
      this.setState({ deleting: true });
      // Send the data to the server
      apiFetch(`/appointments/${e.id}`, { method: "DELETE" })
        .then(() => {
          this.setState({ doomed: null, deleting: false });
          _this.allAppoinments();
          _this.toast.current.show({
            severity: "success",
            summary: "تم بنجاح",
            detail: "تم الحذف بنجاح",
          });
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ doomed: null, deleting: false });
          _this.toast.current.show({
            severity: "error",
            summary: "لم تتم العملية",
            detail: error.message || "خطأ في الإتصال",
          });
        });
    };

    const openAdd = () => this.setState({ addOpen: true });
    const closeAdd = () => {
      this.setState({ addOpen: false });
      this.allAppoinments();
    };

    // a day and a place are what makes an appointment findable
    const canSave = this.state.day !== null && this.state.selectedMaterial !== null;
    const canSaveEdit = this.state.editDay !== null && this.state.editLocation !== null;

    const actionBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Tip text="تعديل">
            <Button
              icon="pi pi-pencil"
              className="p-button-rounded p-button-secondary p-ml-2"
              onClick={() => this.openEdit(rowData)}
            />
          </Tip>
          <Tip text="حذف">
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger"
              onClick={() => this.setState({ doomed: rowData })}
            />
          </Tip>
        </React.Fragment>
      );
    };

    // the day, by name. The response carries `day` as a number; the column
    // used to read `dayText`, which an appointment does not have.
    const dayBody = (row) => (
      <span className="ui-stack">
        <b>{DAY_LABEL[row.day] || "—"}</b>
        <small>{this.state.stagesById[row.schoolStageId] || "كل المراحل"}</small>
      </span>
    );

    // the four times in one cell. Four columns all headed "التوقيت" gave no
    // way to tell them apart, and most rows only use one or two.
    const timesBody = (row) => {
      const times = [row.time, row.time2, row.time3, row.time4]
        .map(fmtTime)
        .filter(Boolean);

      if (!times.length) return <span className="ui-bits is-none">من غير توقيت</span>;

      return (
        <span className="ui-bits">
          {times.map((t, i) => (
            <span className="bit" key={i}>
              <i className="pi pi-clock"></i>
              {t}
            </span>
          ))}
        </span>
      );
    };

    const typeBody = (row) => {
      if (row.appointmentsType === null || row.appointmentsType === undefined) return "—";
      return (
        <Chip kind={TYPE_KIND[row.appointmentsType] || "off"}>
          {TYPE_LABEL[row.appointmentsType] || row.appointmentsType}
        </Chip>
      );
    };

    // one time field, written once and used by both forms
    const timeField = (id, label, value, onChange) => (
      <div className="p-col-12 p-md-4">
        <div className="p-inputgroup">
          <span className="p-float-label">
            <Calendar
              id={id}
              timeOnly
              hourFormat="12"
              value={value}
              onChange={(e) => onChange(e.value)}
            ></Calendar>
            <label htmlFor={id}>{label}</label>
          </span>
        </div>
      </div>
    );

    return (
      <>
        <Header
          pageName="المواعيد"
          action={{ label: "إضافة ميعاد", icon: "pi pi-plus", onClick: openAdd }}
        />
        <Toast ref={this.toast}></Toast>

        {/* The form used to be a whole Card wedged inside the table's own
            header row. Same fields, same handler, same call. */}
        <Panel
          visible={this.state.addOpen}
          onHide={closeAdd}
          title="إضافة ميعاد"
          subtitle="حدد اليوم والمكان والتوقيتات، وهيظهر في الجدول بعد الحفظ"
          actions={
            <Button
              className={`add-button ${this.state.buttonColor}`}
              label={this.state.buttonText}
              disabled={!canSave || this.state.saving}
              onClick={this.addSchedule}
            />
          }
        >
          <div className="add-lesson-page in-panel">
            <div className="content">
              <div className="container">
                <section className="ui-sec" style={{ "--d": "0ms" }}>
                  <h3>
                    <span className="n">١</span>
                    <span className="t">
                      الميعاد
                      <small>اليوم، نوع الميعاد، والمكان اللي هيتم فيه</small>
                    </span>
                  </h3>
                  <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.day}
                            options={DAY_LIST}
                            onChange={(e) => this.setState({ day: e.value })}
                            name="day"
                            placeholder="اختر"
                            showClear
                          />
                          <label>اليوم</label>
                        </span>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.type}
                            options={TYPE_LIST}
                            onChange={(e) => this.setState({ type: e.value })}
                            name="type"
                            placeholder="اختر"
                            showClear
                          />
                          <label>
                            نوع الميعاد
                            <small className="ui-fieldhint">اختياري</small>
                          </label>
                        </span>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.selectedMaterial}
                            options={materialList}
                            placeholder="اختر"
                            onChange={(e) => this.setState({ selectedMaterial: e.value })}
                            optionLabel="label"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingLocations} text="مفيش أماكن" />}
                          />
                          <label>المكان</label>
                        </span>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.schoolStageId}
                            options={grades}
                            onChange={(e) => this.setState({ schoolStageId: e.value })}
                            name="grade"
                            placeholder="اختر"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingGrades} />}
                          />
                          <label>
                            المرحلة الدراسية
                            <small className="ui-fieldhint">اختياري</small>
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="ui-sec" style={{ "--d": "70ms" }}>
                  <h3>
                    <span className="n">٢</span>
                    <span className="t">
                      التوقيتات
                      <small>لحد ٤ توقيتات في نفس اليوم — سيب اللي مش محتاجه فاضي</small>
                    </span>
                  </h3>
                  <div className="p-grid p-fluid">
                    {timeField("add-t1", "التوقيت الأول", this.state.date1, (v) => this.setState({ date1: v }))}
                    {timeField("add-t2", "التوقيت الثاني", this.state.date2, (v) => this.setState({ date2: v }))}
                    {timeField("add-t3", "التوقيت الثالث", this.state.date3, (v) => this.setState({ date3: v }))}
                    {timeField("add-t4", "التوقيت الرابع", this.state.date4, (v) => this.setState({ date4: v }))}
                  </div>
                </section>

                <section className="ui-sec" style={{ "--d": "140ms" }}>
                  <h3>
                    <span className="n">٣</span>
                    <span className="t">
                      ملاحظات
                      <small>اختياري — أي حاجة تحب تفتكرها مع الميعاد ده</small>
                    </span>
                  </h3>
                  <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <InputText
                            id="notes"
                            value={this.state.notes || ""}
                            name="notes"
                            type="text"
                            onChange={(e) => this.setState({ notes: e.target.value })}
                          />
                          <label htmlFor="notes">الملاحظات</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Panel>

        {/* Editing opens the same shape as adding, holding the row's own
            values -- including its place and its own remarks. */}
        <Panel
          visible={!!editRow}
          onHide={this.closeEdit}
          title="تعديل الميعاد"
          subtitle="عدّل البيانات واحفظ، والجدول هيتحدّث لوحده"
          actions={
            <Button
              className="add-button"
              label={this.state.editSaving ? "جاري الحفظ ..." : "حفظ التعديل"}
              disabled={!canSaveEdit || this.state.editSaving}
              onClick={this.edit}
            />
          }
        >
          {editRow ? (
            <div className="add-lesson-page in-panel">
              <div className="content">
                <div className="container">
                  <section className="ui-sec" style={{ "--d": "0ms" }}>
                    <h3>
                      <span className="n">١</span>
                      <span className="t">
                        الميعاد
                        <small>اليوم، نوع الميعاد، والمكان اللي هيتم فيه</small>
                      </span>
                    </h3>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12 p-md-4">
                        <div className="p-inputgroup">
                          <span className="p-float-label">
                            <Dropdown
                              value={this.state.editDay}
                              options={DAY_LIST}
                              onChange={(e) => this.setState({ editDay: e.value })}
                              placeholder="اختر"
                              showClear
                            />
                            <label>اليوم</label>
                          </span>
                        </div>
                      </div>
                      <div className="p-col-12 p-md-4">
                        <div className="p-inputgroup">
                          <span className="p-float-label">
                            <Dropdown
                              value={this.state.editType}
                              options={TYPE_LIST}
                              onChange={(e) => this.setState({ editType: e.value })}
                              placeholder="اختر"
                              showClear
                            />
                            <label>نوع الميعاد</label>
                          </span>
                        </div>
                      </div>
                      <div className="p-col-12 p-md-4">
                        <div className="p-inputgroup">
                          <span className="p-float-label">
                            <Dropdown
                              value={this.state.editLocation}
                              options={materialList}
                              onChange={(e) => this.setState({ editLocation: e.value })}
                              placeholder="اختر"
                              optionLabel="label"
                              showClear
                              emptyMessage={<SelectEmpty loading={this.state.loadingLocations} text="مفيش أماكن" />}
                            />
                            <label>المكان</label>
                          </span>
                        </div>
                      </div>
                      <div className="p-col-12 p-md-4">
                        <div className="p-inputgroup">
                          <span className="p-float-label">
                            <Dropdown
                              value={this.state.editStage}
                              options={grades}
                              onChange={(e) => this.setState({ editStage: e.value })}
                              placeholder="اختر"
                              showClear
                              emptyMessage={<SelectEmpty loading={this.state.loadingGrades} />}
                            />
                            <label>المرحلة الدراسية</label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section className="ui-sec" style={{ "--d": "70ms" }}>
                    <h3>
                      <span className="n">٢</span>
                      <span className="t">
                        التوقيتات
                        <small>لحد ٤ توقيتات في نفس اليوم — سيب اللي مش محتاجه فاضي</small>
                      </span>
                    </h3>
                    <div className="p-grid p-fluid">
                      {timeField("ed-t1", "التوقيت الأول", this.state.editTime1, (v) => this.setState({ editTime1: v }))}
                      {timeField("ed-t2", "التوقيت الثاني", this.state.editTime2, (v) => this.setState({ editTime2: v }))}
                      {timeField("ed-t3", "التوقيت الثالث", this.state.editTime3, (v) => this.setState({ editTime3: v }))}
                      {timeField("ed-t4", "التوقيت الرابع", this.state.editTime4, (v) => this.setState({ editTime4: v }))}
                    </div>
                  </section>

                  <section className="ui-sec" style={{ "--d": "140ms" }}>
                    <h3>
                      <span className="n">٣</span>
                      <span className="t">
                        ملاحظات
                        <small>اختياري — أي حاجة تحب تفتكرها مع الميعاد ده</small>
                      </span>
                    </h3>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12 p-md-12">
                        <div className="p-inputgroup">
                          <span className="p-float-label">
                            <InputText
                              id="edit-notes"
                              value={this.state.editRemarks}
                              type="text"
                              onChange={(e) => this.setState({ editRemarks: e.target.value })}
                            />
                            <label htmlFor="edit-notes">الملاحظات</label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          ) : null}
        </Panel>

        <Confirm
          visible={!!doomed}
          onHide={() => this.setState({ doomed: null })}
          name={doomed ? `${DAY_LABEL[doomed.day] || "الميعاد"}` : ""}
          note="الميعاد هيتشال نهائياً من الجدول، ومش هينفع ترجع عنه."
          busy={deleting}
          onConfirm={() => deletePeriod(doomed)}
        />

        <div className="content">
          <div className="container">
            <div className="card">
              <Card>
                <Toolbar
                  value={this.state.globalFilter || ""}
                  onSearch={(v) => this.setState({ globalFilter: v })}
                  placeholder="بحث في المواعيد"
                  count={tableLoading ? null : `${data.length} ميعاد`}
                />

                <DataTable
                  sortable
                  globalFilter={this.state.globalFilter}
                  className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                  value={data}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  emptyMessage={
                    tableLoading ? (
                      <TableWait />
                    ) : (
                      <EmptyState
                        title="لا يوجد مواعيد"
                        hint="ابدأ بإضافة أول ميعاد في جدولك"
                        icon="pi pi-calendar"
                        action={{ label: "إضافة ميعاد", onClick: openAdd }}
                      />
                    )
                  }
                >
                  <Column sortable field="day" body={dayBody} header="اليوم"></Column>
                  <Column body={timesBody} header="التوقيتات"></Column>
                  <Column
                    sortable
                    field="lessonLocationId"
                    body={(row) => this.state.locationsById[row.lessonLocationId] || "—"}
                    header="المكان"
                  ></Column>
                  <Column sortable field="appointmentsType" body={typeBody} header="النوع"></Column>
                  <Column
                    field="remarks"
                    body={(row) => row.remarks || <span className="ui-bits is-none">—</span>}
                    header="ملاحظات"
                  ></Column>
                  <Column header="تعديل / حذف" body={actionBodyTemplate}></Column>
                </DataTable>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Schedule;
